import React from 'react'
import Pic from './ProfilePic'

const ProfilePic = (props) => (
  <Pic {...props} />
)

export default ProfilePic



// WEBPACK FOOTER //
// src/components/ProfilePic/index.js